import { css } from 'styled-components';

const defaultTheme = {
    StyledProductName: css`
        text-align: left;
    `
};

export default defaultTheme;
